import React, { useEffect } from 'react';
import { Text } from './Text';
import { logEvent } from '../lib/analytics';
import { LoadingStep } from './LoadingStep';

interface ErrorStepProps {
  description: string;
  redirectUrl?: string;
}

export const ErrorStep: React.FC<ErrorStepProps> = ({
  description,
  redirectUrl,
}) => {
  useEffect(() => {
    logEvent({
      category: 'Error Step',
      name: 'Error',
      description,
    });
  }, [description]);

  useEffect(() => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  if (redirectUrl) {
    return <LoadingStep />;
  }

  return (
    <div className="p-6 text-center space-y-3">
      <Text.H5>Something went wrong.</Text.H5>
      <Text.Small>
        We apologize for this inconvenience. Please call us at{' '}
        <a href="tel:1-800-797-0327">1-800-797-0327</a> and we&apos;ll be glad
        to help.
      </Text.Small>
    </div>
  );
};
